const routes = {
  default: "/",
  register: "/register",
  login: "/login",
  connect_wallet: "/connect-wallet",
  home: "/home",
  race: "/race",
  profile: "/profile",
  community: "/community",
  communityArticle: "/community/article",
  account: "/settings/profile",
  security: "/settings/security",
  privacy: "/settings/privacy",
  billing: "/settings/billing",
  user_bets: "/settings/bets",
  settings: "/settings",
  live_games: "/live-games",
  notFound: "/404",
  winning_notification: "/winning-notification",
  serverError: "/5xx",
  // race: (id) => `/race?id=${id}`,
  // Add more as needed
};

export default routes;
